/**
 * Based on https://github.com/necolas/react-native-web/blob/0.17.5/packages/react-native-web/src/modules/pick/index.js
 */
export function createPickProps(forwardPropsList: Record<string, unknown>) {
  return (
    props: Record<string, unknown>,
    additionalAllowed: Record<string, unknown>,
  ) => {
    let result: Record<string, unknown> = {};
    for (let key of Object.keys(props)) {
      if (
        forwardPropsList[key as never] === true ||
        additionalAllowed[key] === true ||
        // Temporary until ARIA is mapped to explicit props
        key.startsWith('aria-')
      ) {
        result[key] = props[key];
      }
    }
    return result;
  };
}
